import { render } from "./DynamicHtmlH3.vue?vue&type=template&id=0a682dcd&ts=true"
import script from "./DynamicHtmlH3.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlH3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlH3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a682dcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a682dcd', __exports__)) {
    api.reload('0a682dcd', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlH3.vue?vue&type=template&id=0a682dcd&ts=true", () => {
    api.rerender('0a682dcd', render)
  })

}


export default __exports__